import {
  sendNotification,
  useEntityMetadata,
  useModuleFederationContext,
  useTranslation,
  useViewBaseMetadata,
} from '@msdk/common'
import { EntityMetadata } from '@msdk/definitions'
import { createComponentWrapperWithRef, styled, uiTokens } from '@msdk/ui'
import React, { useEffect, useState } from 'react'

interface Props {
  entityName: string
  moduleName: string
  children: React.ReactElement
}

const MuiStyledWrapper = styled('div')`
  padding-right: 24px;
`

const NovaStyledWrapper = styled('div')`
  padding-right: 24px;

  > .MuiPaper-root.MuiPaper-rounded.MuiCard-root {
    border-radius: ${uiTokens.radius.large}px;
  }
`

const StyledWrapper = createComponentWrapperWithRef(
  {
    mui: MuiStyledWrapper,
    nova: NovaStyledWrapper,
  },
  'StyledWrapper',
)

export function EmbeddedViewFederationWrapper(props: Props) {
  const { ensureModule, loadedModules } = useModuleFederationContext()
  const entityModel = useEntityMetadata(props.entityName)
  const baseMetadata = useViewBaseMetadata(props.entityName, props.moduleName) as EntityMetadata
  const [msOK, setMsOk] = useState(false)
  const t = useTranslation()

  useEffect(() => {
    if (baseMetadata) {
      ensureModule(props.entityName, props.moduleName, baseMetadata.msProvider, entityModel, true)
      setMsOk(true)
    } else {
      setMsOk(false)
      sendNotification({
        message: t('NOT_FOUND_MS_METADATA_ERROR', 'Some data was not able to be loaded, a microservice is missing'),
        status: 'error',
      })
    }
  }, [])

  const isModuleLoaded = baseMetadata ? !!loadedModules[baseMetadata.msProvider] : false

  return <StyledWrapper>{isModuleLoaded && msOK && props.children}</StyledWrapper>
}
